import naja from "naja";

class ActiveTextColorsExtension {
	constructor(naja) {
		try {
			this.fixColors();
		} catch (e) {
			console.error(e.error);
		}
	}

	fixColors() {
		document.querySelectorAll('[data-bck-color]').forEach((entry) => {
			entry.style.backgroundColor = entry.getAttribute('data-bck-color');
		})
	}
}

naja.registerExtension(ActiveTextColorsExtension);